// extracted by mini-css-extract-plugin
export default {"contentWrap":"CompanyInfo_contentWrap__lvQgb","textWrap":"CompanyInfo_textWrap__Zm9Kc"};